import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconTranslation = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 20 20" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.04492 4.73779C1.04492 4.39261 1.32474 4.11279 1.66992 4.11279L12.2976 4.11279C12.6428 4.11279 12.9226 4.39261 12.9226 4.73779C12.9226 5.08297 12.6428 5.36279 12.2976 5.36279L1.66992 5.36279C1.32474 5.36279 1.04492 5.08297 1.04492 4.73779Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.75516 4.20557C10.0955 4.26292 10.325 4.58535 10.2676 4.92573C9.83439 7.49664 8.86769 9.46257 7.38299 10.8037C5.89577 12.1472 3.95449 12.8044 1.6877 12.8804C1.34271 12.8919 1.05367 12.6217 1.04211 12.2767C1.03054 11.9317 1.30083 11.6426 1.64581 11.6311C3.69276 11.5625 5.32689 10.9766 6.54508 9.87615C7.76579 8.77346 8.63449 7.09478 9.03499 4.71802C9.09235 4.37764 9.41478 4.14821 9.75516 4.20557Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.67711 7.08864C4.97879 6.9209 5.35933 7.02948 5.52707 7.33116C6.4279 8.9513 7.29076 9.93103 8.27817 10.5455C9.26641 11.1604 10.445 11.4506 12.0596 11.5695C12.4038 11.5949 12.6623 11.8945 12.637 12.2387C12.6116 12.583 12.312 12.8415 11.9678 12.8161C10.2582 12.6903 8.85007 12.3736 7.61776 11.6068C6.38462 10.8394 5.39313 9.66255 4.43459 7.9386C4.26685 7.63692 4.37543 7.25638 4.67711 7.08864Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.98877 1.94593C7.33395 1.94654 7.61327 2.22686 7.61266 2.57204L7.60772 5.36378L6.35772 5.36157L6.36266 2.56982C6.36327 2.22465 6.64359 1.94532 6.98877 1.94593Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.8924 7.92481C14.13 7.92383 14.3477 8.05776 14.454 8.27037L18.8924 17.1501C19.0467 17.4588 18.9215 17.8342 18.6128 17.9886C18.304 18.1429 17.9286 18.0177 17.7743 17.709L16.5244 15.2085H11.3308L10.1088 17.7043C9.95706 18.0144 9.5827 18.1426 9.27268 17.9909C8.96266 17.8391 8.83439 17.4647 8.98617 17.1547L13.3336 8.27498C13.4381 8.0615 13.6547 7.92579 13.8924 7.92481ZM11.9428 13.9585H15.8996L13.9007 9.95932L11.9428 13.9585Z"
      fill="currentColor"
    />
  </SvgIcon>
)
